import React from "react";
import { useStore } from "@/context/StoreContext";
import { MessageCircle } from "lucide-react";

export const FloatingContact = () => {
  const { settings } = useStore();
  if (!settings?.whatsapp) return null;
  const number = settings.whatsapp.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hello BooksNmore, I'd like to place an order / make an enquiry."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] text-white font-semibold pl-4 pr-5 py-3 border-2 border-black rounded-full shadow-brutal-black hover:-translate-y-1 hover:shadow-brutal-lg active:translate-y-0 transition-all duration-200"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
      <span className="hidden sm:inline">Order on WhatsApp</span>
    </a>
  );
};
